export const ALIASED_PACKAGES = [
  "react",
  "react-dom",
  "react-router-dom",
  "react-dnd",
  "react-dnd-html5-backend",
  "react-select",
  "react-helmet-async",
  "@tanstack/react-query",
  "@tanstack/react-table",
  "@emotion/react",
  "medusa-react",
  "@medusajs/ui",
  "@medusajs/icons",
  "@medusajs/ui-preset",
] as const
